/**
 * @generated SignedSource<<55fd8f060f7ba6adac1b39e49eb7703e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Unit4LogPage_viewer$data = {
  readonly unit4LogItems: ReadonlyArray<{
    readonly id: string | null;
    readonly type: string | null;
    readonly unit4Identifier: string | null;
    readonly personId: number | null;
    readonly person: string | null;
    readonly projectId: number | null;
    readonly project: string | null;
    readonly workorder: string | null;
    readonly taskId: number | null;
    readonly task: string | null;
    readonly date: string | null;
    readonly minutesRegistered: string | null;
    readonly notes: string | null;
    readonly errorMessage: string | null;
  } | null> | null;
  readonly " $fragmentType": "Unit4LogPage_viewer";
};
export type Unit4LogPage_viewer$key = {
  readonly " $data"?: Unit4LogPage_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"Unit4LogPage_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Unit4LogPage_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Unit4LogItemType",
      "kind": "LinkedField",
      "name": "unit4LogItems",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unit4Identifier",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "personId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "person",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "project",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "workorder",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "taskId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "task",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "date",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minutesRegistered",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "notes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "errorMessage",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "7fa382c57d3146fc2b70f227af929996";

export default node;
